module.exports = __webpack_public_path__ + "img/img6.af3db9c2.png";